<template>
    <div class="content">
        <div class="word">
            <p class="b">北京红松在线科技有限公司</p>
            <p> 公司致力于“为企业战略决策提供专业解决方案”的企业</p>
            <p>始终秉承“客户至上、创新务实、专业专注、诚信规范”的经营理念,</p>
            <p>以客户至上的态度服务客户、以创新务实的精神塑造团队、</p>
            <p>以专业专注的品格开展业务、以诚信规范的准绳经营企业。</p>
        </div>
        <div class="erwei"></div>
    </div>
</template>

<script>
    export default {
        name: "Home"
    }
</script>

<style scoped lang="scss">
    .content {
        background: transparent;
        width: 100%;
        padding: 0px 100px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .word {
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 27.5px;
            letter-spacing: 1px;
            text-align: left;
        }

        .erwei {
            width: 174px;
            height: 174px;
            background: url("../assets/img/hs-erweima.png") center/contain no-repeat;
        }
    }

    .b {
        font-size: 16px;
        font-weight: 600;
    }
</style>